import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import AccountsWithoutNewInvoicesDetails from '../../../components/launchComponents/Admin/accounts/accountswithoutnewinvoices/accountswithoutnewinvoicesdetails';
import AccountsWillExpireDetails from '../../../components/launchComponents/Admin/accounts/accountswillexpire/accountswillexpiredetails';
import DisabledAccountsDetails from '../../../components/launchComponents/Admin/accounts/disabledaccounts/disabledaccountsdetails';
import CashOnlyDetails from '../../../components/launchComponents/Admin/accounts/cashonly/cashonlydetails';
import ExpiredAccountDetails from '../../../components/launchComponents/Admin/accounts/expiredaccounts/expiredaccountsdetails';
import AccountByDepartmentDetails from '../../../components/launchComponents/Admin/accounts/accountbydepartment/accountbydepartmentdetails';
import {withRouter} from 'react-router-dom';

class AdminAccountDetailPage extends Component {
    render() {
        return ( <div>                                   
                        <Route exact path="/adminaccountdetail/accountswithoutnewinvoicesdetails" component={AccountsWithoutNewInvoicesDetails} />
                        <Route exact path="/adminaccountdetail/accountswillexpiredetails" component={AccountsWillExpireDetails} />
                        <Route exact path="/adminaccountdetail/disabledaccountsdetails" component={DisabledAccountsDetails} />
                        <Route exact path="/adminaccountdetail/cashonlyaccountsdetails" component={CashOnlyDetails} />
                        <Route exact path="/adminaccountdetail/expiredaccountsdetails" component={ExpiredAccountDetails} />
                        <Route exact path="/adminaccountdetail/accountbydepartmentdetails" component={AccountByDepartmentDetails} />
                                           
        </div>)
    }

}
export default withRouter(AdminAccountDetailPage)